import type { Locale } from "@/i18n"
import type { Uuid } from "@/utils"

export enum VerificationStatus {
  Verified = "verified",
  Unverified = "unverified",
  UnverifiedExpired = "unverified_expired",
}

export type User = {
  readonly id: Uuid
  readonly name: string
  readonly initials: string
  readonly nickName: string | null
}

export type LoginRequest = {
  readonly email: string
  readonly password: string
}

// Terms consent is click-through ("By continuing, you agree…"), not a flag
export type RegisterRequest = {
  readonly email: string
  // Null signs up passwordless: a sign-in link is emailed instead
  readonly password: string | null
  // The locale the signup happened in (from the public /{locale}/ URL); seeds
  // User.locale and their Personal Workspace's default.
  readonly locale: Locale
}

export type RegisterResponse = TokenResponse | { readonly loginLinkSent: true }

export type ChangePasswordPayload = {
  readonly password: string
}

export type TokenResponse = {
  readonly token: string
  readonly refreshToken: string
}

export enum SocialProvider {
  Google = "google",
}

export type ConnectRequest = {
  readonly provider: SocialProvider
  // The locale the social signup started in; new social users land in it.
  readonly locale: Locale
}

export type ConnectResponse = {
  readonly authUrl: string
}
